
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/contentstack",
      function () {
        return require("private-next-pages/destinations/contentstack.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/contentstack"])
      });
    }
  